import "./assets/main.css";
import { createSSRApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { createAppRouter } from "./router/createRouter.js";
import { routerHolder } from "./router/instance.js";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fas, fab, far);

/**
 * @param {{ ssr?: boolean }} opts
 */
export function createApp(opts = {}) {
    const ssr = Boolean(opts.ssr);
    const app = createSSRApp(App);
    const pinia = createPinia();
    const router = createAppRouter(ssr);

    routerHolder.router = router;

    app.use(pinia);
    app.use(router);

    app.config.globalProperties.$filters = {
        currencySAR(value) {
            const val = value / 1;
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    };

    app.component("font-awesome-icon", FontAwesomeIcon);

    return { app, router, pinia };
}
